import { render, staticRenderFns } from "./AlientFontTest.vue?vue&type=template&id=16dd4d90&scoped=true&"
import script from "./AlientFontTest.vue?vue&type=script&lang=ts&"
export * from "./AlientFontTest.vue?vue&type=script&lang=ts&"
import style0 from "./AlientFontTest.vue?vue&type=style&index=0&id=16dd4d90&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dd4d90",
  null
  
)

export default component.exports